export default __webpack_public_path__ + "static/media/Inter-roman.var.73d88d2c.woff2";